import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  savePhaseItem,
  deletePhaseItem,
  requestPhaseItems,
} from 'actionCreators/phase_items';
import { addFlagToPhase, removeFlagFromPhase } from 'actionCreators/phase';
import { can } from '../../../../../../../../services';
import { getRole } from '../../../../../../../../reducers';

import LineItemTable from 'components/LineItemTable';
import ContractorChargebackRow from 'contractorChargebackRow';
import contractorChargebackItemShape from 'types/contractorChargebackItem';
import documentType from 'types/documentUpload';
import FlagType from 'types/flag';

const LINE_ITEM_TYPE = 'contractorChargebackItems';
const FLAG = {
  name: 'Chargeback to be Reviewed',
  note: 'Chargeback has been entered for review.',
};

class ContractorChargebackTable extends Component {
  componentWillMount() {
    this.refreshLineItemList();
  }

  updateFlags = (res, lineItem) => {
    if (!(res.type.indexOf('_SUCCESS') > -1)) return;

    if (!lineItem.status) {
      const { phaseId } = this.props;
      this.props.addFlagToPhase(phaseId, FLAG);
    } else if (lineItem.status === 'Ready for Accounting') {
      const { phaseId, flags } = this.props;
      const oldFlag = flags.find(flag => flag.name === FLAG.name &&
                                         flag.note === FLAG.note,
      );

      if (oldFlag) this.props.removeFlagFromPhase(phaseId, oldFlag);
    }
  }

  refreshLineItemList = () => {
    this.props.requestPhaseItems(this.props.phaseId, LINE_ITEM_TYPE);
  }

  handleDelete = (lineItemId) => {
    this.props.deletePhaseItem(this.props.phaseId, { id: lineItemId }, LINE_ITEM_TYPE);
  }

  handleSave = (lineItem) => {
    this.props.savePhaseItem(this.props.phaseId, lineItem, LINE_ITEM_TYPE).then((res) => {
      this.updateFlags(res, lineItem);
    });
  }

  render() {
    const { lineItems, documents, editable, phaseSource, role } = this.props;
    const total = lineItems.reduce((curr, next) => curr + (next.total || 0), 0);
    return (
      <LineItemTable
        title="Chargebacks"
        refreshList={this.refreshLineItemList}
        total={total}
        readOnly={!editable}
        accountingTable
      >
        {lineItems.map(item =>
          <ContractorChargebackRow
            key={item.id}
            onSave={this.handleSave}
            onDelete={this.handleDelete}
            lineItem={item}
            documents={documents}
            hasCreatableRow={editable}
            readOnly={!can(role, 'update', 'chargeback', { obj_status: item.status })}
            role={role}
            source={phaseSource}
          />,
        )}
      </LineItemTable>
    );
  }
}

ContractorChargebackTable.defaultProps = {
  lineItems: [],
};

ContractorChargebackTable.propTypes = {
  phaseId: PropTypes.string,
  requestPhaseItems: PropTypes.func,
  savePhaseItem: PropTypes.func,
  deletePhaseItem: PropTypes.func,
  lineItems: PropTypes.arrayOf(
    PropTypes.shape(contractorChargebackItemShape),
  ),
  documents: PropTypes.arrayOf(documentType).isRequired,
  addFlagToPhase: PropTypes.func.isRequired,
  removeFlagFromPhase: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  role: PropTypes.string,
  phaseSource: PropTypes.string,
  flags: PropTypes.arrayOf(FlagType),
};

export default connect(state => ({
  editable: can(getRole(state), 'editable', 'chargeback'),
  role: getRole(state),
  flags: state.phase.details.flags,
}),
  {
    savePhaseItem,
    deletePhaseItem,
    requestPhaseItems,
    addFlagToPhase,
    removeFlagFromPhase,
  })(ContractorChargebackTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorChargebackTable.jsx